import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { getApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

const envConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

function getHostedAuthDomain() {
  if (typeof window === "undefined") {
    return null;
  }

  const { hostname, protocol } = window.location;
  if (protocol !== "https:") {
    return null;
  }

  if (
    hostname.endsWith(".web.app") ||
    hostname.endsWith(".firebaseapp.com")
  ) {
    return hostname;
  }

  return null;
}

export function resolveAuthDomain(configuredAuthDomain = envConfig.authDomain) {
  return getHostedAuthDomain() || configuredAuthDomain || "timer.quest";
}

export const firebaseConfig = {
  apiKey: envConfig.apiKey || "AIzaSyCz4n26ht_AfHjd6I6_xt4aI9KPl4dgiB4",
  authDomain: resolveAuthDomain(),
  projectId: envConfig.projectId || "timer-quest",
  storageBucket: envConfig.storageBucket || "timer-quest.appspot.com",
  messagingSenderId: envConfig.messagingSenderId || "592406424738",
  appId: envConfig.appId || "1:592406424738:web:442f3d935a4359552f3bfb",
  measurementId: envConfig.measurementId || "G-TT44X84C1C",
};
const functionsRegion = process.env.REACT_APP_FUNCTIONS_REGION || "europe-west1";

firebase.initializeApp(firebaseConfig);
const app = getApp();
const db = getFirestore();
let appCheckInstance;

export function initializeFirebaseAppCheck(
  siteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_KEY,
) {
  if (process.env.NODE_ENV === "development" || !siteKey) {
    return null;
  }

  if (appCheckInstance) {
    return appCheckInstance;
  }

  try {
    appCheckInstance = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
    return appCheckInstance;
  } catch (_e) {
    return null;
  }
}

export function getAppCheckInstance() {
  return appCheckInstance;
}

if (process.env.REACT_APP_ENV === "local") {
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}

export function getDb() {
  return db;
}

export function getUserId() {
  return firebase.auth().currentUser?.uid;
}

export const callFunction = async (
  endpoint,
  data = {},
  method = "POST",
  headers = {},
  responseType = "json",
) => {
  try {
    const isProd =
      process.env.NODE_ENV && process.env.NODE_ENV === "production";
    const user = firebase.auth().currentUser;
    // Only fetch a new token if we have a user and no Authorization set yet
    let token;
    if (user) {
      try {
        token = await user.getIdToken();
      } catch (_e) {
        token = undefined;
      }
    }
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    headers["Content-Type"] = "application/json";
    headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
    headers["Pragma"] = "no-cache";
    headers["Expires"] = "0";

    // Normalize method: accept boolean (true => POST, false => GET), string, or null/undefined
    const normalizedMethod =
      typeof method === "string"
        ? method.toUpperCase()
        : method === false
        ? "GET"
        : "POST";

    let options = {
      method: normalizedMethod,
      headers: headers,
    };

    if (normalizedMethod === "GET") {
      const searchParams = new URLSearchParams(data);
      const queryString = searchParams.toString();
      if (queryString) {
        endpoint = `${endpoint}?${queryString}`;
      }
    } else {
      options.body = JSON.stringify(data);
    }

    const url = isProd
      ? `/api/${endpoint}`
      : `http://127.0.0.1:5001/${firebaseConfig.projectId}/${functionsRegion}/api/${endpoint}`;
    
    const response = await fetch(url, options);

    const result = { ok: response.ok, status: response.status };
    if (responseType === "blob") {
      const blob = await response.blob();
      return { ...result, blob };
    }
    let json = null;
    try {
      json = await response.json();
    } catch (_e) {
      // Non-JSON response
    }
    if (json && typeof json === "object") {
      return { ...json, ...result };
    }
    return { data: json, ...result };
  } catch (e) {
    console.error("API call failed:", e);
    return { error: "API call failed" };
  }
};
